import { cancelCopyFileInMainProcess, copyFileInMainProcess } from '@mimir/web/desktop/utils';
import { backendClientCloudLogger } from '@mimir/client-common/util/cloudLogger';
import type { CopyParams } from '@mimir/common/upload/fileCopyUpload';
import { copyFileOptimizedForP2Cards } from '@mimir/common/upload/fileCopyUpload';
import type { UploadManagerOptions} from '@mimir/common/upload/upload';
import type { StructuredLogger } from '@mimir/primitive/structuredLogger';
import { globalBackendClient } from '@mimir/client-common/globals/backendClient';
import { isInElectron, type AdobePanelContext, type ElectronContext } from '@mimir/common/context/applicationContext';
import { features, getGlobalStore, quashableAxios } from './index';
import { ConsoleLogger } from '@mimir/common/util/logging';

let slog: StructuredLogger | undefined;

const logger = new ConsoleLogger();

export const uploadManagerOptions: UploadManagerOptions = {
  client: globalBackendClient,
  axios: quashableAxios.axios,
  getUploadDirectory: async () => {
    const store = getGlobalStore();
    if (store.getters.preferredLocalUploadPath !== null) {
      logger.info(`getUploadDirectory preferred: ${store.getters.preferredLocalUploadPath}`);
      return store.getters.preferredLocalUploadPath;
    }

    // fallback to the value in the settings page only if nothing has been explicitly specified in the upload dialog
    await store.dispatch('prepareUploadLocation', false);
    logger.info(`getUploadDirectory default: ${store.getters.localUploadPath}`);
    return store.getters.localUploadPath;
  },
  features,
  logger,
  getLogger: () => {
    if (slog == null) {
      slog = backendClientCloudLogger(globalBackendClient);
    }
    return slog;
  },
  copyFileOptimizedForDesktop: (applicationContext: AdobePanelContext | ElectronContext, params: CopyParams) => {
    if (isInElectron(applicationContext)) {
      return copyFileInMainProcess(applicationContext, params);
    }

    return copyFileOptimizedForP2Cards(params);
  },
  cancelCopyFileOptimizedForDesktop: (applicationContext: AdobePanelContext | ElectronContext, exeutionId: string) => {
    if (isInElectron(applicationContext)) {
      return cancelCopyFileInMainProcess(applicationContext, exeutionId);
    }
  },
  getThisClientInstanceId: () => getGlobalStore().getters.thisClientInstanceId,
};
